export default __webpack_public_path__ + "static/media/remoteControlExample.1b4e4eb9.png";